export const SEARCH_DEFAULT_SORT = 'relevance';
export const BROWSE_DEFAULT_SORT = 'best-sellers';
